import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  containerCampos: {
    paddingBottom: theme.spacing(3),
  },
  titleCampo: {
    fontSize: '15px',
    marginTop: theme.spacing(2),
  },
  field: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2.5),
  },
  buttons: {
    marginTop: theme.spacing(2),
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 'none',
    borderRadius: theme.shape.borderRadius,
  },
}))
